// @flow
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

type Props = {
  active: boolean,
  onClick?: void,
};

const useStyles = makeStyles((theme) => ({
  line: {
    display: 'inline-block',
    width: 200,
    height: 10,
    borderRadius: 5,
    backgroundColor: (props) =>
      props.active ? theme.palette.primary.main : 'white',
    marginRight: 20,
    '&:last-child': { marginRight: 0 },

    [theme.breakpoints.down('sm')]: {
      width: 50,
      height: 5,
    },
  },
}));

const Line = ({ active, onClick }: Props) => {
  const classes = useStyles({ active });

  /* eslint-disable-next-line */
  return <button type="button" className={classes.line} onClick={onClick} />;
};

export default Line;
